import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { CDSExportMessageTypes } from 'store/declarations/enums/common/declaration-types';

// Note: mirroring currently only goes from an Ireland Import H1 to a UK Export B1. Once more pairs
// are supported this becomes a lookup keyed by the source declaration rather than a constant.
export const MIRRORED_DECLARATION_TARGET = {
    country: DeclarationCountry.UK,
    internalType: DeclarationInternalType.EXPORT,
    messageType: CDSExportMessageTypes.B1,
};

// A single UK Export B1 holds at most this many items - a source with more is split across several.
export const MAX_ITEMS_PER_MIRRORED_DECLARATION = 99;

// The BE pages the mirrored declarations list (10 by default), and a large H1 splits into more B1s than that.
export const MIRRORED_DECLARATIONS_PAGE_SIZE = 50;
